import { Component } from '@angular/core';

@Component({
  selector: 'app-table-actions',
  templateUrl: './table-actions.component.html'
})
export class TableActionsComponent {
}
